import { useTireSizeOptions } from "./useTireSizeOptions";

export const useHasTireSizeOptions = (): boolean =>
  useTireSizeOptions().some(({ isStaggered }) => isStaggered);
